/* this file is transformed by vux-loader */
/* eslint-disable */
import _typeof from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import router from '@/router';
import store from '@/store';
var arrApi = '/hd/order/h5/save/addbymobilePhone';
var arrApi1 = '/hd/oa/file/list';
var arrApi2 = '/file/upload';
var arrApi3 = '/hd/order/h5/save/details';
var arrApi4 = '/hd/order/h5/save/service/content';
var arrApi5 = '/hd/order/h5/save/service/progress';

function request(config) {
  var session = store.state.appStore.sessionID;
  config.headers.token = session;

  if (arrApi === config.url || arrApi1 === config.url || arrApi2 === config.url || arrApi3 === config.url || arrApi4 === config.url || arrApi5 === config.url) {
    // 使用到pc端接口 域名
    // config.baseURL = 'http://192.168.1.10:8087/'
    if (process.env.NODE_ENV == 'development') config.baseURL = 'http://asapptest.huadianswg.cn:8080';else config.baseURL = 'http://asapp.huadianswg.cn'; // config.baseURL = 'http://asapp.huadianswg.cn'
  } else {
    // h5 域名
    // config.baseURL = 'http://192.168.1.10:8080/'
    // config.baseURL = 'http://as.huadianswg.cn/'
    console.log(process.env.NODE_ENV); // if (process.env.NODE_ENV == 'development') config.baseURL = 'http://astest.huadianswg.cn:8080'
    // else config.baseURL = ''
  }

  if (config.method !== 'get') {
    var user = store.state.globalStore.user;

    if (user && Object.keys(user).length > 0) {
      var ctoken = user.csrfToken;

      if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
        // 判断参数是否经过stringify转换
        if (_typeof(config.data) === 'object') {
          config.data.ctoken = ctoken;
        } else {
          if (config.data) {
            config.data += '&ctoken=' + ctoken;
          } else {
            config.data = 'ctoken=' + ctoken;
          }
        }
      } else if (config.method === 'delete') {
        if (config.url.indexOf('?') === -1) {
          config.url += '?ctoken=' + ctoken;
        } else {
          config.url += '&ctoken=' + ctoken;
        }
      }
    }
  }

  return config;
}

function responce(res) {
  try {
    if (res) {
      switch (res.status) {
        case 200:
          if (res.data.message === '未登录') {
            router.push({
              name: 'CodeLogin',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
            return res;
          } else {
            return res;
          }

      }
    }
  } catch (e) {
    return Promise.reject(e);
  }
}

export default {
  request: request,
  responce: responce
};